import React from 'react'

import { Avatar, Typography, Chip } from '@material-ui/core'

import { makeStyles } from '@material-ui/core/styles'

import { getAvatarLetters, getPetAge } from '../../../services/helpers'

import clsx from 'clsx'
import { useHistory } from 'react-router-dom'
import { useSelector } from 'react-redux'
import moment from 'moment'

const useStyles = makeStyles((theme) => ({
	nameContainer: {
		display: 'flex',
		alignItems: 'center',
		'&.deactivated': {
			opacity: '0.6'
		}
	},
	avatar: {
		marginRight: '16px'
	},
	name: {
		fontSize: '16px',
		lineHeight: '22px'
	},
	groupCol: {
		minWidth: '10%',
		maxWidth: '24%',
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		padding: '5px',
		paddingRight: '24px',
		borderRight: '1px solid #D0CFD2',
		'& p': {
			margin: 0
		},
		'& .change': {
			fontFamily: 'Nunito',
			fontSize: 14,
			fontWeight: '600',
			color: '#6B4AD6',
			lineHeight: '23px',
			cursor: 'pointer'
		},
		'& .char': {
			fontFamily: 'Nunito',
			fontSize: 14,
			fontWeight: '600',
			color: '#6B4AD6',
			lineHeight: '23px',
			cursor: 'pointer',
			backgroundColor: 'rgba(107, 74, 214, 0.1)',
			padding: 4,
			borderRadius: 6,
			marginRight: 4,
			marginBottom: 4
		},
		'&:last-child': {
			borderRight: 'none'
		},
		'&:nth-child(n+1)': {
			paddingLeft: '24px'
		}
	},
	group: {
		width: '100%',
		padding: 15,
		backgroundColor: '#FFF',
		borderRadius: 6,
		marginBottom: 24,
		boxShadow: '0px 2px 10px rgba(26, 26, 53, 0.1)'
	},
	topRow: {
		width: '100%',
		display: 'flex',
		flexDirection: 'row',
		justifyContent: 'space-between',
		alignItems: 'center',
		cursor: 'pointer',
		marginBottom: 16
	},
	groupBody: {
		width: '100%',
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'flex-start',
		padding: 15,
		backgroundColor: '#F9F9F9',
		borderRadius: 6,
		'&.deactivated': {
			opacity: '0.6'
		}
	},
	chip: {
		marginLeft: 16,
		'& .MuiChip-label': {
			textTransform: 'uppercase',
			marginRight: 0
		}
	}
}))

const PetCard = (props) => {
	const classes = useStyles()
	const history = useHistory()
	const facility = useSelector((state) => state.specific.facilities.selected)
	const client = useSelector((state) => state.specific.households.selected)
	let { pet } = props
	const navigateToPet = () => {
		history.push(`/clients/${client._id}/pets/${pet._id}`)
	}

	return (
		<div className={clsx([classes.group, { deactivated: !pet.active }])}>
			<div className={classes.topRow} onClick={navigateToPet}>
				<div className={clsx([classes.nameContainer, { deactivated: !pet.active }])}>
					<Avatar className={classes.avatar} alt={pet.name} src={pet.image_url ? pet.image_url : null}>
						{getAvatarLetters(pet.name)}
					</Avatar>
					<Typography variant="overline" className={classes.name}>
						{pet.name}
					</Typography>
					{!pet.active ? <Chip className={classes.chip} label="Deactivated" /> : null}
				</div>
				<i className="fa fa-chevron-right" />
			</div>
			<div className={clsx([classes.groupBody, { deactivated: !pet.active }])}>
				<div className={classes.groupCol}>
					<Typography variant="overline" className={clsx([classes.colTitle, classes.breed])}>
						Breed
					</Typography>
					<Typography variant="body2">{pet?.breeds?.length ? pet.breeds.join(", ") : 'Unknown'}</Typography>
				</div>
				<div className={classes.groupCol}>
					<Typography variant="overline" className={clsx([classes.colTitle, classes.age])}>
						Age
					</Typography>
					<Typography variant="body2">
						{pet && pet.birthday ? getPetAge(pet.birthday) : 'Unknown'}
					</Typography>
				</div>
				<div className={classes.groupCol}>
					<Typography variant="overline" className={clsx([classes.colTitle, classes.color])}>
						Color
					</Typography>
					<Typography variant="body2">{pet.color ? pet.color : 'Unknown'}</Typography>
				</div>
				<div className={classes.groupCol}>
					<Typography variant="overline" className={clsx([classes.colTitle, classes.characteristics])}>
						Characteristics
					</Typography>
				</div>
			</div>
		</div>
	)
}

export default PetCard
